import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionEmpleadosHogarByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionEmpleadosHogarByUser = () => {
  const [loadingGetPrestacionEmpleadosHogarByUser, setLoadingGetPrestacionEmpleadosHogarByUser] = useState(false);
  const [successGetPrestacionEmpleadosHogarByUser, setSuccessGetPrestacionEmpleadosHogarByUser] = useState(false);
  const [errorGetPrestacionEmpleadosHogarByUser, setErrorGetPrestacionEmpleadosHogarByUser] = useState<any>(null);
  const [dataGetPrestacionEmpleadosHogarByUser, setDataPrestacionEmpleadosHogarByUser] = useState<any>(null);

  const [statusGetPrestacionEmpleadosHogarByUser, setStatusGetPrestacionEmpleadosHogarByUser] =
    useState<StatusGetPrestacionEmpleadosHogarByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getPrestacionEmpleadosHogarByUser = async (
    userId: string,
    expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPrestacionEmpleadosHogarByUser(true);
    setSuccessGetPrestacionEmpleadosHogarByUser(false);
    setErrorGetPrestacionEmpleadosHogarByUser(null);

    try {
      const res = await apirecord.getCertificadoPrestacionEmpleoHogarByUser(userId, expedienteId);

      setStatusGetPrestacionEmpleadosHogarByUser({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetPrestacionEmpleadosHogarByUser(true);
      setDataPrestacionEmpleadosHogarByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetPrestacionEmpleadosHogarByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetPrestacionEmpleadosHogarByUser(err);
      console.error("Error en getPrestacionEmpleadosHogarByUser:", err);

      throw err;

    } finally {
      setLoadingGetPrestacionEmpleadosHogarByUser(false);
    }
  };

  return {
    getPrestacionEmpleadosHogarByUser,
    loadingGetPrestacionEmpleadosHogarByUser,
    successGetPrestacionEmpleadosHogarByUser,
    errorGetPrestacionEmpleadosHogarByUser,
    dataGetPrestacionEmpleadosHogarByUser,
    statusGetPrestacionEmpleadosHogarByUser
  };
};

export default useGetPrestacionEmpleadosHogarByUser;
